import { render, staticRenderFns } from "./SelectVoyageLeg.vue?vue&type=template&id=61cd5f25&"
import script from "./SelectVoyageLeg.vue?vue&type=script&lang=js&"
export * from "./SelectVoyageLeg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports